<script setup>
import { ref } from 'vue'
import FormButton from './FormButton.vue';

const isVisible = ref(false)
const emit = defineEmits(['click'])

const props = defineProps({
  type: {
    type: String,
    default: 'main',
  },
  size: {
    type: String,
    default: 'md',
  },
  isCustom: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
  },
  position: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  isText: {
    type: Boolean,
    default: false,
  },
  customClasses: {
    type: String,
  },
  id: {
    type: String,
  },
  to: {
    type: String,
  },
})

const toggleDropdown = () => {
  isVisible.value = !isVisible.value
}

// Only emit: in Vue 3 a parent's @click arrives as the onClick vnode prop,
// which emit() invokes directly. Calling props.onClick here too would fire
// the handler twice.
const handleClick = (event) => {
  emit('click', event)
}
</script>

<template>
  <li class="[&>*]:last:rounded-b-md [&>*]:first:rounded-t-md">
    <slot v-if="isCustom" />
    <div v-else-if="isText" :class="customClasses ? customClasses : 'h-8 p-2 text-surface-7 text-nowrap leading-none text-tiny flex items-center w-full max-w-[90vw] truncate'">
      <slot />
    </div>
    <FormButton :id="id" :customClasses="customClasses ? customClasses : 'h-10 md:h-8 !p-3 md:!p-2 hover:bg-surface-3 text-surface-text-1 hover:text-white text-nowrap leading-none text-base md:text-tiny flex items-center w-full max-w-[90vw] truncate disabled:text-surface-6'" :type="type" :size="size" v-else-if="!to" @click="handleClick" :disabled="disabled">
      <slot />
    </FormButton>
    <router-link :class="customClasses ? customClasses : 'h-8 p-2 hover:bg-surface-3 hover:text-white hover:no-underline text-nowrap leading-none text-tiny flex items-center w-full max-w-[90vw] truncate'" v-else :to="to">
      <slot />
    </router-link>
  </li>
</template>

<style></style>
